import GGLA from '../resources/image/GGLA.png';
import TEV2 from '../resources/image/TEV2.png';
import VEFB from '../resources/image/VEFB.png';

export const ServiceTypeInfo = [
    {
        keycode: 'GGLA',
        icon: GGLA
    },
    {
        keycode: 'TEV2',
        icon: TEV2
    },
    {
        keycode: 'VEFB',
        icon: VEFB
    }
];
